import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CreateComponent } from './create/create.component';
import { SearchComponent } from './search/search.component';
import { AuthGuard, SharedModule } from '../../../shared';
import { TemplateService } from './template.service';
import { NgbdModalCustomclass } from './create/modal-customclass';
import { NgbdModalCustomclassgroup } from './create/modal-customclassgroup';
import { NgbdModalCustomclasssection } from './create/modal-customclasssection';
import { NgbdModalCustomclasssectiongroup } from './create/modal-customclasssectiongroup';
import { NgbdModalSectionPopup } from './create/modal-sectionpopup';

const staffRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'setting/dfb/create-template',
    component: CreateComponent,
    canActivate: [AuthGuard]	
  },
  {
    path: 'setting/dfb/search-template',
    component: SearchComponent,
    canActivate: [AuthGuard]	
  }
]);


@NgModule({
  imports: [
    SharedModule,
    staffRouting,
    NgbModule.forRoot()
  ],
  declarations: [
    CreateComponent,
    SearchComponent,
	NgbdModalCustomclass,
	NgbdModalCustomclassgroup,
	NgbdModalCustomclasssection,
	NgbdModalCustomclasssectiongroup,
	NgbdModalSectionPopup
  ],
  providers: [TemplateService]
})
export class TemplateModule {}



// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/template/template.module.ts